import React, { useState, KeyboardEvent } from 'react';
import { TextField } from '@td-client-frontend/common';
import { PiwikName, PiwikCategory, PiwikAction } from '../../@types/common';
import { trackEvent } from '../../api/piwik/piwikService';
import { SearchAction, SearchActionButton } from './SearchActionButton';

const minSearchNum = 3;

interface Props {
  loading: boolean;
  onSearch: (value: string) => void;
}

const addTrackEvent = (name: PiwikName) => {
  trackEvent({
    category: PiwikCategory.BUTTONS,
    action: PiwikAction.CLICKED,
    name: name
  });
};

export const Search = ({ onSearch, loading }: Props) => {
  const [value, setValue] = useState<string>('');
  const [focused, setFocused] = React.useState<boolean>(false); // React.useState for testing purpose
  const [valid, setValid] = useState<boolean>(true);

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const validSearch = !value || value.length >= minSearchNum;
    setValid(validSearch);
    setValue(value);
  };

  const onBlur = () => {
    setFocused(false);
    handleSubmit(value.toLowerCase());
  };

  const onFocus = () => setFocused(true);

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      setFocused(false);
      handleSubmit(value.toLowerCase(), PiwikName.SEARCH_BOX_KEYBOARD);
    }
  };

  const clearSearch = () => {
    setValue('');
    handleSubmit('', PiwikName.SEARCH_BOX_CLICK);
  };

  const handleSubmit = (searchString: string, trackEvent: PiwikName = PiwikName.SEARCH_BOX_CLICK) => {
    if (valid) {
      addTrackEvent(trackEvent);
      onSearch(searchString.toLowerCase());
    }
  };

  const onSearchAction = (action: SearchAction) => {
    if (action === SearchAction.CLEAR) {
      clearSearch();
    } else {
      handleSubmit(value);
    }
  };

  const rightButton = <SearchActionButton value={value} loading={loading} focused={focused} onClick={onSearchAction} />;

  return (
    <TextField
      name="groupsearch"
      label="Search employers"
      data-testid="groupsearch"
      aria-label="Search Groups Field"
      placeholder="Search Employer or Group Number"
      onChange={onSearchChange}
      onFocus={onFocus}
      onBlur={onBlur}
      value={value}
      onKeyDown={onKeyDown}
      Right={rightButton}
      error={`Should type ${minSearchNum} characters`}
      isError={!valid}
      disabled={loading}
    />
  );
};

export default Search;
